export enum WrapTag {
    None = '',
    Section = 'section',
    Div = 'div',
    Address = 'address',
    Article = 'article'
}